var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c(
            "pod-charge-search-bar",
            {
              attrs: { filter: _vm.filter },
              on: {
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery,
                onGridRefresh: _vm.gridRefresh,
                reset: _vm.resetGrid
              }
            },
            [
              _vm.activeTabName === "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEdit",
                            type: "primary",
                            disabled: !this.cpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onDeleteCP", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName !== "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEdit1",
                            type: "primary",
                            disabled: !this.ppSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "onDeletePP",
                            type: "danger",
                            disabled:
                              !_vm.selectedPpRows ||
                              _vm.selectedPpRows.length === 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.approveAllowed_PP,
                              expression: "approveAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onApprovePP",
                            type: "primary",
                            disabled:
                              !_vm.selectedPpRows ||
                              _vm.selectedPpRows.length === 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.onApprove_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Approve")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.approveAllowed_PP && _vm.filter.level === 0,
                              expression:
                                "approveAllowed_PP && filter.level === 0"
                            }
                          ],
                          attrs: {
                            no: "onMarkupApprove",
                            type: "primary",
                            disabled:
                              !_vm.selectedPpRows ||
                              _vm.selectedPpRows.length === 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.onMarkupApprove()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.markupApprove")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isHQManager,
                              expression: "isHQManager"
                            }
                          ],
                          attrs: {
                            no: "onConfigPriceAir",
                            type: "primary",
                            disabled: false
                          },
                          on: {
                            click: function($event) {
                              return _vm.onConfigPriceAir()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Setting")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onAddPP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onDownloadTemplate", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "savePodChargeExcelFile",
                            action: _vm.URL.price.savePodChargeExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "on-success": _vm.uploadExcelSuccess,
                            data: {
                              currentOfficeId:
                                _vm.$store.getters.currentOfficeId
                            }
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { no: "import", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("pol-charge-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "cpList",
                      "config-module": "224101",
                      "show-cost": true,
                      "show-create": true,
                      "show-modify": true,
                      "show-approve": true,
                      "show-selection": true,
                      "row-data": _vm.rowCpData,
                      "grid-options": _vm.cpGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  }),
                  _c(
                    "div",
                    {
                      ref: "txtCpRemark",
                      staticStyle: { height: "6%", width: "99%" },
                      on: {
                        dblclick: function($event) {
                          return _vm.onTxtRemarksDoubleClick()
                        }
                      }
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.txtCpRemarks,
                            expression: "txtCpRemarks"
                          }
                        ],
                        staticStyle: {
                          width: "100%",
                          "margin-left": "10px",
                          height: "100%"
                        },
                        attrs: {
                          no: "txtCpRemarks",
                          disabled: true,
                          title: _vm.$t("Pricing.RemarkAreaToolTip")
                        },
                        domProps: { value: _vm.txtCpRemarks },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.txtCpRemarks = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("pol-charge-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      "config-module": "224102",
                      "show-cost": true,
                      "show-create": true,
                      "show-modify": true,
                      "show-selection": true,
                      "row-data": _vm.rowPpData,
                      "grid-options": _vm.ppGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  }),
                  _c(
                    "div",
                    {
                      ref: "txtPpRemark",
                      staticStyle: { height: "6%", width: "99%" },
                      on: {
                        dblclick: function($event) {
                          return _vm.onTxtRemarksDoubleClick()
                        }
                      }
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.txtPpRemarks,
                            expression: "txtPpRemarks"
                          }
                        ],
                        staticStyle: {
                          width: "100%",
                          "margin-left": "10px",
                          height: "100%"
                        },
                        attrs: {
                          no: "txtPpRemarks2",
                          disabled: true,
                          title: _vm.$t("Pricing.RemarkAreaToolTip")
                        },
                        domProps: { value: _vm.txtPpRemarks },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.txtPpRemarks = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                left: "160px",
                margin: "10px"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.globalMsg))])]
          )
        ],
        1
      ),
      _vm.podChargeFormDialog.visible
        ? _c("pod-charge-form", {
            attrs: {
              visible: _vm.podChargeFormDialog.visible,
              price: _vm.podChargeFormDialog.price,
              "is-new": _vm.podChargeFormDialog.isNew,
              "is-cp": _vm.isActiveCpTab,
              level: _vm.filter.level
            },
            on: {
              close: function($event) {
                _vm.podChargeFormDialog.visible = false
              },
              reload: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.airMarkupDialog.visible
        ? _c("air-markup-popup", {
            ref: "airMarkupPopup",
            attrs: {
              visible: _vm.airMarkupDialog.visible,
              "config-util": _vm.configUtil,
              keys: _vm.airMarkupDialog.keys,
              "selected-rows": _vm.airMarkupDialog.selectedRows
            },
            on: {
              close: function($event) {
                _vm.airMarkupDialog.visible = false
              },
              approveSuccess: _vm.onApproveSuccess
            }
          })
        : _vm._e(),
      _vm.airSettingsPopupDialog.visible
        ? _c("air-settings-popup", {
            ref: "airSettingsPopup",
            attrs: {
              visible: _vm.airSettingsPopupDialog.visible,
              "config-util": _vm.configUtil,
              "is-h-q-manager": _vm.isHQManager
            },
            on: {
              close: function($event) {
                _vm.airSettingsPopupDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }